import React from 'react';
import { EventStateProvider } from '@apps/acquisitionFunnels/createWedding/EventState';
import { AllowedDesignParamsProvider } from '@apps/acquisitionFunnels/createWedding/components/AllowedDesignParamsProvider';

type FormFlowProvidersProps = Readonly<{
  children: React.ReactNode;
}>;

export const FormFlowProviders: React.FC<FormFlowProvidersProps> = ({ children }) => {
  return (
    <EventStateProvider>
      <AllowedDesignParamsProvider>{children}</AllowedDesignParamsProvider>
    </EventStateProvider>
  );
};
